import { Directive } from '@angular/core';

@Directive({
    selector: 'app-label',
    standalone: false,
})
export class LabelDirective {
}
